import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../../redux/authSlice'
import { getBackendUrl } from '../../../endpoints'

var lastActivityTime = new Date()

const InactivityHandler = () => {
    const dispatch = useDispatch()
    const token = useSelector((state) => state.auth.token)
    const [isDimmed, setIsDimmed] = useState(false);
    const activityIntervalRef = useRef(null);
    
    const SCREENSAVER_TIMEOUT = (process.env.SCREENSAVER_TIMEOUT ?? 18000) * 1000
    
    const handleActivity = () => {
        lastActivityTime = new Date();
        setIsDimmed(false)
    };

    useEffect(() => {
        const events = ["mousemove", "keydown", "scroll", "click", "touchstart"];
        events.forEach((event) => window.addEventListener(event, handleActivity));
        
        activityIntervalRef.current = setInterval(() => {
            if (!isDimmed) {
                if (lastActivityTime.getTime() + SCREENSAVER_TIMEOUT / 2 < (new Date).getTime()) {
                    setIsDimmed(true)
                }
            }
            
            if (lastActivityTime.getTime() + SCREENSAVER_TIMEOUT < (new Date).getTime()) {
                // Full logout: clear local state, revoke token on backend + clear cookies.
                const logoutToken = token
                dispatch(logout())
                window.location.assign(getBackendUrl('/logout', logoutToken))
            }
        }, 1000);

        return () => {
            events.forEach((event) => window.removeEventListener(event, handleActivity));
            clearInterval(activityIntervalRef.current);
        };
    }, [dispatch, token]);

    return (
        <>
            {isDimmed ?
            <div style={{position: 'fixed', left: '0px', top: '0px', right: '0px', bottom: '0px', backgroundColor: '#000000', opacity: 0.5, zIndex: 10000}}>
            </div>
            : null }
        </>
    );
};

export default InactivityHandler;